import ManageContentContainer from "library/show/components/content/manage/ManageContentContainer"

const ManageSubmission = ({ content }) => (
  <ManageContentContainer prompt="How should each person submit?" />
)

export default ManageSubmission
